module.exports = require('./lib').combineReducers;
